import { Dialog } from "@rio-cloud/rio-uikit";
import { Select } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import { OccurrenceDispatch } from "../../../../../../../models/occurrence";
import { Occurrence } from "../../../../../../../models/occurrence";
import SuccessDialog from "../../../../../../dialogs/SuccessDialog";
import ErrorDialog from "../../../../../../dialogs/ErrorDialog";
import { reasonsRefusalOptions } from "../../../../../../../hooks/useDispatch";

interface CancelDispatchDialogProps {
  open: boolean;
  onClose: () => void;
  occurrence?: Occurrence | null;
  occurrenceDispatch: OccurrenceDispatch;
  cancelDispatch?: (occurrence: Occurrence, dispatch: OccurrenceDispatch, reason: string, description: string) => Promise<{ wasCanceled: boolean, error?: string, dispatch?: OccurrenceDispatch }>;
  updateStatus: (status: string, reason: string, description: string) => void;
}

const CancelDispatchDialog = (props: CancelDispatchDialogProps) => {
  const [loading, setLoading] = useState(false);

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorDialogBody, setErrorDialogBody] = useState<string>("");
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  const [form, setForm] = useState<{
    reason: string;
    description: string;
  }>({
    reason: "",
    description: "",
  });

  const isFormValid = form.reason !== "" && form.description.trim() !== "";

  return (
    <>
      <Dialog
        show={props.open}
        onClose={props.onClose}
        showCloseButton
        bsSize={Dialog.SIZE_MD}
      >
        <>
          <Dialog.Title title={"Indisponibilidade"} />
          <Dialog.Body>
            <div className="cancel-content flex flex-col">
              <div className="form-group form-group-lg w-full">
                <label className="truncate">Motivo da indisponibilidade</label>
                <Select
                  id="1"
                  placeholder="Selecione o tipo de ocorrência"
                  options={reasonsRefusalOptions}
                  onChange={(option: any) =>
                    setForm({ ...form, reason: option?.id ?? "" })
                  }
                />
              </div>

              <div className="form-group form-group-lg w-full">
                <label className="!font-bold" htmlFor="textParecer">
                  Parecer
                </label>
                <textarea
                  className="form-control !h-[100px]"
                  id="textParecer"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                ></textarea>
              </div>

              <hr />

              <div className="flex flex-col gap-6 py-[10px]">
                <span className="text-size-14 text-color-dark">
                  Você está prestes a recusar a agenda solicitada
                </span>
                <span className="text-size-14 text-color-dark">
                  Deseja continuar mesmo assim?
                </span>
              </div>
            </div>
          </Dialog.Body>
          <Dialog.Footer>
            <div className="flex items-center justify-end py-[10px]">
              <div className="flex items-center gap-6">
                <p
                  className="text-bold text-size-16 cursor-pointer text-color-primary"
                  onClick={props.onClose}
                >
                  Voltar
                </p>
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={!isFormValid || loading}
                  onClick={async () => {
                    if (!props.occurrence || !props.cancelDispatch) {
                      setShowErrorDialog(true);
                      setErrorDialogBody("Ocorrência não encontrada");
                      return;
                    }

                    setLoading(true);
                    const { wasCanceled, error, dispatch } = await props.cancelDispatch(props.occurrence, props.occurrenceDispatch, form.reason, form.description);
                    if (wasCanceled) {
                      props.onClose();
                      props.updateStatus("Indisponível para atendimento", form.reason, form.description);
                    } else {
                      setShowErrorDialog(true);
                      setErrorDialogBody(error ?? "Erro ao cancelar acionamento");
                    }
                    setLoading(false);
                  }}
                >
                  Continuar
                </button>
              </div>
            </div>
          </Dialog.Footer>
        </>
      </Dialog>

      <ErrorDialog
        show={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        title="Erro ao cancelar acionamento"
        body={errorDialogBody}
      />

      <SuccessDialog  
        show={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        title="Acionamento cancelado com sucesso"
        body="O acionamento foi cancelado com sucesso."
      />
    </>
  );
};

export default CancelDispatchDialog;
